import { InjectionToken } from '@angular/core';

import type { DoodOpenCheck } from '@core/models/check.model';

/** Runtime VM emitted by `CheckDetailsBlock` data sources. */
export type CheckDetailsBlockViewModel = {
  check: DoodOpenCheck | null;
};

export const CHECK_DETAILS_BLOCK_LOADING_VM: CheckDetailsBlockViewModel = {
  check: null,
};

export interface CheckDetailsBlockDataSource {
  readonly vm$: import('rxjs').Observable<CheckDetailsBlockViewModel>;
}

export const CHECK_DETAILS_BLOCK_DATA_SOURCE = new InjectionToken<CheckDetailsBlockDataSource>(
  'CHECK_DETAILS_BLOCK_DATA_SOURCE',
);
